import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {getBeersList} from 'services/beers';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';

import {setStyleBeersAC, setStyleBeersIncludedAC, setStyleBeersPageInfoAC} from '../beerStyleViewSlice';
import {getBeerStyleBeersACS} from '../requests';

export function* getBeerStyleBeersSaga(action: ReturnType<typeof getBeerStyleBeersACS>) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {page, ...dto} = action.payload;

  try {
    const response: AxiosResponse<ApiData<Beer[]>> = yield call(getBeersList, {...dto, page: 1});

    yield put(setStyleBeersAC(response.data.data));
    yield put(
      setStyleBeersPageInfoAC({
        totalPages: response.data.meta.total_pages,
        totalCount: response.data.meta.total_count,
      }),
    );
    yield put(setStyleBeersIncludedAC(response.data.included));
  } catch (error) {
    yield call(handleError, error, 'Could not get list of beers with beer style');
  }
}
